export class GradientConfig {
  public static config = {
    layout: 'vertical', // vertical, horizontal
    subLayout: '', // horizontal-2
    collapseMenu: false,
    layoutType: 'menu-light', // menu-dark, menu-light, dark
    headerBackColor: 'white', // header-blue, header-red, header-purple, header-info, header-dark, header-orenge
    // header-green, header-yellow, header-orchidgreen, header-indigogreen, header-darkgreen, header-darkblue
    rtlLayout: false,
    navFixedLayout: true,
    headerFixedLayout: true,
    boxLayout: false,
  };
}
